/** Where the locked aspect ratio comes from during a diagonal corner resize. */
export enum NodeContentSizing {
  /** Single image/video/3D: lock the media frame's ratio; box height follows the media (no gap). */
  Media = 'media',
  /** Multi-file grid: lock the grid's ratio; box height follows the grid (no gap). */
  Grid = 'grid',
  /** Audio, text, empty: lock the node box's own aspect ratio. */
  Box = 'box',
}
